export default __webpack_public_path__ + "static/media/arrow-down.inline.ab0d96af.svg";